import ReactModal from "react-modal";

interface DeliveryErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DeliveryErrorModal: React.FC<DeliveryErrorModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Delivery Fee Error"
      className="modal"
      overlayClassName="overlay"
    >
      <button onClick={onClose} className="text-black">
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div className="text-center">
        <p>
          Sorry, the address you entered is out of the merchant delivery range.
        </p>
        <p>Please choose pick up or enter a new address.</p>
        <button
          onClick={onClose}
          className="bg-red-500 text-white py-2 px-4 rounded mt-4"
        >
          Close Window
        </button>
      </div>
    </ReactModal>
  );
};

export default DeliveryErrorModal;
